import { Flex } from "@evergis/ui";
import React, { FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Label, MaxZoomLevelContainer, ZoomSlider, ZoomType, ZoomTypeContainer } from "../styled";
import { useUploadDataContext } from "../uploadDataContext";
import { zoomTypesImages } from "./assets";

export const UploadMaxZoomLevel: FC = () => {
  const { t } = useTranslation("dialogs");
  const { maxZoomLevel, setMaxZoomLevel } = useUploadDataContext();

  useEffect(() => {
    if (maxZoomLevel === undefined) {
      setMaxZoomLevel(0);
    }
  }, [maxZoomLevel]);

  const formattedMaxZoomLevel = maxZoomLevel || 0;
  const zoomTypes = useMemo(
    () => [
      { min: 0, max: 2, img: zoomTypesImages.earth, label: t("uploadData.earth") },
      { min: 3, max: 4, img: zoomTypesImages.continent, label: t("uploadData.continent") },
      { min: 5, max: 6, img: zoomTypesImages.country, label: t("uploadData.country") },
      { min: 7, max: 8, img: zoomTypesImages.regions, label: t("uploadData.regions") },
      { min: 9, max: 10, img: zoomTypesImages.districts, label: t("uploadData.districts") },
      { min: 11, max: 12, img: zoomTypesImages.city, label: t("uploadData.city") },
      { min: 13, max: 14, img: zoomTypesImages.streets, label: t("uploadData.streets") },
      { min: 15, max: 16, img: zoomTypesImages.quarters, label: t("uploadData.quarters") },
      { min: 17, max: 18, img: zoomTypesImages.houses, label: t("uploadData.houses") },
    ],
    [t],
  );
  const currentZoomType = useMemo(
    () => zoomTypes.find(({ min, max }) => formattedMaxZoomLevel >= min && formattedMaxZoomLevel <= max),
    [formattedMaxZoomLevel, zoomTypes],
  );

  return (
    <MaxZoomLevelContainer>
      <Flex style={{ flexWrap: "nowrap" }}>
        <div style={{ width: "100%" }}>
          <Label>{t("uploadData.maxTileScale")}</Label>
          <ZoomSlider
            value={formattedMaxZoomLevel}
            onChange={setMaxZoomLevel}
            showStepMarks={false}
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            marks={[0, 6, 8, 12, 18]}
            min={0}
            max={18}
            step={1}
            sliderWidth={710}
          />
        </div>
        <ZoomTypeContainer>
          <ZoomType img={currentZoomType.img} />
          <Label>{currentZoomType.label}</Label>
        </ZoomTypeContainer>
      </Flex>
    </MaxZoomLevelContainer>
  );
};
